"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dropdown", {
    staticClass: "international",
    attrs: {
      trigger: "click"
    },
    on: {
      command: _vm.handleSetLanguage
    }
  }, [_c("div", [_c("img", {
    style: _vm.dynamicStyle,
    attrs: {
      src: require("../../assets/svg/lang.svg"),
      alt: ""
    }
  })]), _vm._v(" "), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("el-dropdown-item", {
    attrs: {
      disabled: _vm.language === "zh",
      command: "zh"
    }
  }, [_vm._v("\n            中文\n        ")]), _vm._v(" "), _c("el-dropdown-item", {
    attrs: {
      disabled: _vm.language === "en",
      command: "en"
    }
  }, [_vm._v("\n            English\n        ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;